'use client';

import * as React from 'react';
import clsx from 'clsx';
import { slug as githubSlug } from 'github-slugger';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next-nprogress-bar';
import {
  ScrollArea,
  ScrollBar,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from 'ui';
import type { NormalizedSortBy } from '../_components/types';
import { pathPrefixAtom } from '../../_components/blog-state';
import {
  showSortMenuAtom,
  showTagTabsAtom,
} from '../../_components/design-state';

export interface BlogTabsProps {
  children: React.ReactNode;
  tag: string;
  sortBy: NormalizedSortBy;
}

export function BlogTabs(props: BlogTabsProps): JSX.Element {
  const router = useRouter();
  const urlPrefix = useAtomValue(pathPrefixAtom);
  return (
    <Tabs
      activationMode="manual"
      className="pb-16 xs:pb-24"
      id="tag-tabs"
      onValueChange={(v) => {
        router.push(`${urlPrefix}/category/${v}/1/${props.sortBy}#tag-tabs`);
      }}
      value={props.tag}
    >
      {props.children}
    </Tabs>
  );
}
export function BlogTabList({ tags }: { tags: string[] }) {
  const showTagTabs = useAtomValue(showTagTabsAtom);
  const showSortMenu = useAtomValue(showSortMenuAtom);
  if (!showTagTabs) {
    return null;
  }
  return (
    <TabsList>
      <ScrollArea
        className={clsx(
          'flex-1 justify-start!',
          showSortMenu ? 'max-w-227.5' : 'max-w-280',
        )}
      >
        <div className="flex gap-4 overflow-x-auto">
          {tags.map((tag) => (
            <TabsTrigger key={tag} value={githubSlug(tag)}>
              {tag}
            </TabsTrigger>
          ))}
        </div>
        <ScrollBar orientation="horizontal" />
      </ScrollArea>
    </TabsList>
  );
}

export const BlogTabsContent = TabsContent;
